/** Saved, unit-specific progress. Producers persist these metrics on the existing StudyRun step. */
import * as z from 'zod';
const count = z.number().int().nonnegative();
export const shopifyStudyNodeProgressMetricsSchema = z
    .object({
    unit: z.enum([
        'original_conversations',
        'decisions',
        'question_writes',
        'follow_up_answers',
        'analysis_batches',
        'consolidations',
        'reviews',
        'publications',
    ]),
    expected: count,
    succeeded: count,
    failed: count,
    uncertain: count,
    skipped: count,
    cancelled: count,
    outstanding: count,
    activity: z.enum(['running', 'waiting_dependency', 'capacity_wait', 'recovering']).optional(),
    dependency: z.string().min(1).optional(),
    updated_at: z.iso.datetime({ offset: true }),
    diagnostic_code: z.string().min(1).optional(),
})
    .strict()
    .refine((value) => value.succeeded + value.failed + value.uncertain + value.skipped + value.cancelled + value.outstanding ===
    value.expected, 'Progress outcomes must account for the accepted denominator exactly.');
export const shopifyStudyNodeProgressSchema = z.object({
    nodeId: z.string().min(1),
    stepKey: z.string().min(1),
    /** The saved step/group state, not a claim that every output succeeded. */
    state: z.string().min(1),
    metrics: shopifyStudyNodeProgressMetricsSchema.optional(),
    diagnosticCode: z.string().min(1).optional(),
});
//# sourceMappingURL=shopify-study-node-progress.js.map